import superagent from 'superagent';
import webservice from './webservice';

export default async function getLogin({ form }) {
  const url = `${webservice}/getConsultoriaLogin`;

  let json = {
    usuario: form.kitname,
    claveAcceso: form.kitpassword,
  };

  let response = {};

  await superagent
    .post(url)
    .timeout({
      response: 10000, // Wait 5 seconds for the server to start sending,
      deadline: 60000, // but allow 1 minute for the file to finish loading.
    })
    .set('Content-Type', 'application/json')
    .set('seccion', 'CONSULTORIA')
    .send(json)
    .then((res) => {
      response = res.body;
    })
    .catch((err) => {
      console.log(err);
      const resp = {
        ...form,
        error: err,
        tipoMensaje: 'error',
        mensaje: 'Error',
      };
      response = resp;
    });

  return response;
}
